import { RentalUnitType } from '../units/unit.data';

export interface ProtocolData {
  id: string;
  estateId: string;
  agreementId: string;
  rentalUnitId: string;
  rentalUnitType: RentalUnitType;
  landlordIds: string[];
  attachments: string[];
  type: ProtocolType;
  timestamp: number;
  deleted?: boolean;
}

export enum ProtocolType {
  DELIVERY = 'delivery',
  ACCEPTANCE = 'acceptance',
  BEFORE_ACCEPTANCE = 'beforeAcceptance',
  OTHER = 'other'
}
